module.exports = __webpack_public_path__ + "static/media/hooli.16bafc16.svg";